import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ServiceCard from './components/ServiceCard';
import ChiSiamo from './components/ChiSiamo';
import Service from './components/Service';
import Contact from './components/Contact';
import Consulenza from './components/Consulenza';
import Footer from './components/Footer';
import './App.css';

/* 🔹 Redirect esterno per CORSI */
function CorsiRedirect() {
  useEffect(() => {
    window.location.href =  "https://serene-meerkat-3872f9.netlify.app/";
  }, []);

  return null;
}

function App() {
  return (
    <Router>
      <div className="andromeda-app text-light">
        {/* 🔹 Navbar visibile su tutte le pagine */}
        <Navbar />

        {/* 🔹 SEO globale */}
        <Helmet>
          <meta charSet="utf-8" />
          <meta name="robots" content="index, follow" />
          <meta name="author" content="Andromeda Programmazione" />
          <meta name="theme-color" content="#0d0d0d" />
          <link rel="canonical" href="https://www.andromedaprog.it" />
        </Helmet>

        <Routes>

          {/* HOME */}
          <Route
            path="/"
            element={
              <main id="home">
                <Helmet>
                  <title>Andromeda Programmazione | Siti Web e Software su Misura</title>
                </Helmet>
                <Hero />
                <ServiceCard />
                <Contact />
              </main>
            }
          />

          {/* SERVIZI */}
          <Route
            path="/servizi"
            element={
              <main id="servizi">
                <Helmet>
                  <title>Servizi | Andromeda Programmazione</title>
                </Helmet>
                <Service />
              </main>
            }
          />

          {/* CHI SIAMO */}
          <Route
            path="/chi-siamo"
            element={
              <main id="chi-siamo">
                <Helmet>
                  <title>Chi Siamo | Andromeda Programmazione</title>
                </Helmet>
                <ChiSiamo />
              </main>
            }
          />

          {/* CONTATTI */}
          <Route
            path="/contatti"
            element={
              <main id="contatti">
                <Helmet>
                  <title>Contattaci | Andromeda Programmazione</title>
                </Helmet>
                <Contact />
              </main>
            }
          />

          {/* CONSULENZA */}
          <Route
            path="/consulenza"
            element={
              <main id="consulenza">
                <Helmet>
                  <title>Consulenza | Andromeda Programmazione</title>
                </Helmet>
                <Consulenza />
              </main>
            }
          />

          {/* ✅ CORSI (redirect esterno) */}
          <Route path="/corsi" element={<CorsiRedirect />} />

        </Routes>

        {/* 🔹 Footer */}
        <footer>
          <Footer />
        </footer>
      </div>
    </Router>
  );
}

export default App;
